/* eslint-disable */
import {Service} from 'components/Shared/server';
import {AutoCompleteSuggestion} from 'models/AutoCompleteSuggestion';


export const routeGetAutoComplete = (phrase: string) => `/api/search/autocomplete?phrase=${encodeURIComponent(phrase)}`;
export function getAutoComplete(phrase: string): Promise<AutoCompleteSuggestion> {
  return Service.get<AutoCompleteSuggestion>({
    url: routeGetAutoComplete(phrase)
  });
}
